<script>
import { Bar } from 'vue-chartjs'

export default {
  extends: Bar,
  props: {
    height: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 0,
    },
    dayName: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      chartData: {
        labels: ['', '', '9:00', '', '', '12:00', '', '', '15:00', '', '', '18:00', '', '', '21:00', '', ''],
        datasets: [{
          label: null,
          backgroundColor:'#0174bf',
          data: []
        }]
      },
      options: {
        title: {
          display: false,
        },
        legend: {
          display: false
        },
        scales: {
          xAxes: [{
            barPercentage: 1.1,
            gridLines: {
              drawTicks: false,
              drawOnChartArea: false,
            },
            ticks: {
              padding: 6,
              fontColor: '#9d9d9d',
              autoSkip: false,
              maxRotation: 0,
              minRotation: 0
            },
          }],
          yAxes: [{
            display: false,
            ticks: {
              beginAtZero: true,
            }
          }]
        },
        tooltips: {
          enabled: false
        },
      }
    }
  },
  computed: {
    isShow: ({$store}) => $store.state.destinationDetail.isShow,
    destinationSpot: ({ $store }) => $store.state.searchResult.destination,
    stayTimeEachDayAndHour: ({ destinationSpot }) => destinationSpot.report.stayTimeEachDayAndHour,
  },
  watch: {
    destinationSpot(value) {
      this.changeData();
    },
    isShow(value) {
      if (!value) return;
      this.changeData();
    },
  },
  mounted() {
    this.changeData();
  },
  methods: {
    changeData() {
      if (!this.stayTimeEachDayAndHour[this.dayName]) return;
      const day = this.stayTimeEachDayAndHour[this.dayName].slice(6, 23).map((hour) => {
        return hour == 0 ? null : hour;
      });
      this.chartData.datasets[0].data = day;
      this.renderChart(this.chartData, this.options)
    },
  },
}
</script>



// WEBPACK FOOTER //
// spot_congestion_chart.vue?348401ae